import { render } from "./AvaliacaoDeRisco.vue?vue&type=template&id=c61e0dbc"
import script from "./AvaliacaoDeRisco.vue?vue&type=script&lang=js"
export * from "./AvaliacaoDeRisco.vue?vue&type=script&lang=js"

import "./AvaliacaoDeRisco.vue?vue&type=style&index=0&id=c61e0dbc&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__